import React, { FC, useEffect, useState } from 'react'
import { LandingHeroProps } from './LandingHero.types'
import './LandingHero.scss'
import { sanitizeHTML } from '../../utils/common-utils'

export const LandingHero: FC<LandingHeroProps> = props => {
  const { content } = props
  const {
    backgroundImageUrl,
    logoImageUrl,
    logoAltText,
    heading,
    messageImage,
    messageImageAltText,
    mobileImage,
    mobileImageTitle,
  } = content

  const [vh, setVh] = useState(window.innerHeight)
  useEffect(() => {
    const handleResize = () => setVh(window.innerHeight)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return (
    <>
      <style
        type='text/css'
        dangerouslySetInnerHTML={{
          __html: `
        .LendingHero { background: url("${backgroundImageUrl}"); 
        // height:"${vh}px"
        }

      `,
        }}
      />
      <section className='LendingHero'>
        <img
          className='LendingHero--MainImage u-sm-hidden'
          src={messageImage}
          alt={messageImageAltText}
        />
        <div className='u-lg-hidden u-md-hidden'>
          <img className='LendingHero--MainImage' src={mobileImage} alt={messageImageAltText} />
          <h3 className='u-textColorWhite u-textCenter'>{mobileImageTitle}</h3>
        </div>

        <img
          className='LendingHero--SecondaryImage u-sm-marginTop32'
          src={logoImageUrl}
          alt={logoAltText}
        />
        <hr className='LendingHero--sroke u-textColorAmpfBlue' />
        <div
          className='LendingHero--text u-textColorAmpfBlue'
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(heading) }}></div>
      </section>
    </>
  )
}
